import { createActions } from 'redux-actions';

export const { openHelpDialog, closeDialog } = createActions({
  OPEN_HELP_DIALOG: () => {},
  CLOSE_DIALOG: () => {}
});



// WEBPACK FOOTER //
// ./src/store/dialogs/actions.js